import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<{
	text: string;
	display: boolean;
}>;

export function useImpressionCalculation(): Result {
	const { translate } = useI18n();

	const {
		data: {
			featureConfigs: { useDonationLanguage },
		},
	} = usePromotePageData();

	const text = translate('corgi.co.promote.promotion_calculator_text_donation');

	return {
		data: {
			display: useDonationLanguage,
			text,
		},
	};
}
